import navigation from "./village-pub/navigation";

navigation();

if (document.querySelector(".js-accordion")) {
  import("./components/accordion").then((init) => init.default());
}

if (document.querySelector(".js-referral-bar")) {
  import("./village-pub/referralBar").then((init) => init.default());
}

if (document.querySelector(".js-slidetoggle")) {
  import("./village-pub/slideToggle").then((init) => init.default());
}

if (document.querySelector(".js-carousel-locations-container, .plate-panel, .carousel-panel")) {
  import("./village-pub/carousel").then((init) => init.default());
}

if (document.querySelector(".js-filter-group")) {
  import("./village-pub/filter").then((init) => init.default());
}

if (document.querySelector(".js-thing-question")) {
  import("./village-pub/thingsToKnow").then((init) => init.default());
}

if (document.querySelector(".js-image-gallery")) {
  import("./village-pub/imageGallery").then((init) => init.default());
}

if (document.querySelector(".js-room-explorer")) {
  import("./components/roomExplorer").then((init) => init.default());
}

if (document.querySelector(".js-menu-list-panel-carousel")) {
  import("./components/carousel/menuListPanelCarousel").then((init) =>
    init.default()
  );
}

if (document.querySelector(".js-stacked-cards")) {
  import("./components/stackedCards").then((init) => init.default());
}

if (document.querySelector(".js-tabs")) {
  import("./components/tabs").then((init) => init.default());
}

if (document.querySelector("lite-vimeo")) {
  import("./utils/videoFacade").then((init) => init.default());
}
